<template>
  <div class="electronic-rent-money">
    <breadcrumb :breadcrumb="breadcrumb" />

    <div style="margin-top: 10px;">
      <el-tabs v-model="billTabName" @tab-click="billTabClick" type="card">
        <el-tab-pane label="购券账单" name="purchaseBill">
          <div class="search-line" style="margin-top: 10px;">
            <div class="btn-box">
              <div class="btn-box" style="margin-right: 10px;">
                <span style="margin-right: 10px">付费时间</span>
                <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                                :picker-options="pickerOptions2" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期"
                                align="right" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </div>
              <input-select selectTitle="缴费状态" :selectData="payStatusList" @search="search" :selectKey="'status'" />
            </div>
            <div class="btn-box">
              <input-search placeholder="住户名称/房间号" @search="searchKey" style="margin-right: 10px;"/>
              <button-export :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" value="导出" v-if="permissionCodes.indexOf('004033001') !== -1"/>
            </div>
          </div>
          <table-main v-if="billTabName === 'purchaseBill'" :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="rechargeOperationArr" @seeExample="seeExample" :hasOperation="false"/>
        </el-tab-pane>
        <el-tab-pane label="退券账单" name="refundBill">
          <div class="search-line" style="margin-top: 10px;">
            <div class="btn-box">
              <div class="btn-box" style="margin-right: 10px;">
                <span style="margin-right: 10px">付费时间</span>
                <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                                :picker-options="pickerOptions2" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期"
                                align="right" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </div>
              <input-select selectTitle="缴费状态" :selectData="payStatusList" @search="search" :selectKey="'status'" />
            </div>
            <div class="btn-box">
              <input-search placeholder="住户名称/房间号" @search="searchKey" style="margin-right: 10px;"/>
              <button-export :href="exportUrl" :beforeDownload="beforeDownload" download="download.xls" value="导出" v-if="permissionCodes.indexOf('004034001') !== -1"/>
            </div>
          </div>
          <table-main v-if="billTabName === 'refundBill'" :selection="false" :tableHead="monthlyTableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" @seeExample="seeExample" :hasOperation="false"/>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog title="优惠券详情" :visible.sync="dialogVisible" width="25%">
      <div>
        <div class="detail-item">
          <div>优惠券名称</div>
          <div>{{detailData.couponName}}</div>
        </div>
        <div class="detail-item">
          <div>优惠券类型</div>
          <div>{{detailData.couponType}}</div>
        </div>
        <div class="detail-item">
          <div>优惠券张数</div>
          <div>{{detailData.couponNum}}</div>
        </div>
        <div class="detail-item">
          <div>优惠券售价(元)</div>
          <div>{{detailData.couponPrice}}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { bus } from "../../../utils/bus";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";
import ButtonCancel from "../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "parking-coupon-bill",
  data() {
    return {
      timevalue: [],
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "优惠券账单"
        }
      ],
      exportUrl: "",
      payStatusList: [
        {key: "", label: "全部"},
        {key: "0", label: "等待支付"},
        {key: "1", label: "支付成功"},
        {key: "2", label: "支付失败"},
        {key: "3", label: "等待退款"},
        {key: "4", label: "退款成功"},
        {key: "5", label: "退款失败"}
      ],
      tableHead: [
        {
          prop: "enterpriseName",
          label: "商户名称"
        },
        {
          prop: "couponName",
          label: "优惠券名称"
        },
        {
          prop: "coupon",
          label: "优惠券详情",
          example: true
        },
        {
          prop: "billTime",
          label: "出售时间"
        },
        {
          prop: "saleNum",
          label: "出售份数"
        },
        {
          prop: "money",
          label: "出售总金额(元)"
        },
        {
          prop: "saleTotalNum",
          label: "出售总张数"
        },
        {
          prop: "statusText",
          label: "付费状态"
        },
        {
          prop: "payTime",
          label: "付费时间"
        },
      ],
      rechargeOperationArr: [],
      operationArr: [],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
        payStatus: "",
        status: ""
      },


      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },

      billTabName: "purchaseBill",
      monthlyTableHead: [
        {
          prop: "enterpriseName",
          label: "商户名称"
        },
        {
          prop: "couponName",
          label: "优惠券名称"
        },
        {
          prop: "coupon",
          label: "优惠券详情",
          example: true
        },
        {
          prop: "returnNum",
          label: "退券张数"
        },
        {
          prop: "returnMoney",
          label: "退券金额"
        },
        {
          prop: "returnTime",
          label: "退券时间"
        },
      ],

      dialogVisible:false,
      detailData:[]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      let url = ''
      if (this.billTabName === "purchaseBill") {
        url = api.exportParkingCouponBillPage;
      } else {
        url = api.exportParkingCouponBillReturnPage;
      }
      this.exportUrl = `${url}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&payStatus=${this.requestData.payStatus}&status=${this.requestData.status}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`;
    },
    billTabClick() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.requestData.status = "";
      this.getPage();
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || '';
        this.requestData.endTime = this.timevalue[1] || '';
      } else {
        this.requestData.startTime = '';
        this.requestData.endTime = '';
      }
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      let url = "";
      if (this.billTabName === "purchaseBill") {
        url = api.getParkingCouponBillPage;
      } else {
        url = api.getParkingCouponBillReturnPage;
      }
      this.$axios.post(url, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            if (v.status === "0") {
              v.statusText = "等待支付";
            } else if (v.status === "1") {
              v.statusText = "支付成功";
            } else if (v.status === "2") {
              v.statusText = "支付失败";
            } else if (v.status === "3") {
              v.statusText = "等待退款";
            } else if (v.status === "4") {
              v.statusText = "退款成功";
            } else if (v.status === "5") {
              v.statusText = "退款失败";
            }
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取信息失败"));
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },

    seeExample(data){
      this.detailData=data;
      this.dialogVisible = true;
    },
  },
  watch: {
    timevalue() {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
.form-line {
  margin: 5px 0 20px 0;
  display: flex;
  justify-content: flex-start;
}
.line-text {
  color: #48576a;
  font-size: 14px;
}
.textBox {
  display: inline-block;
  width: 130px;
  line-height: 32px;
  text-align: right;
}
.red {
  color: #ff0000;
}
</style>

<style lang="less">
.electronic-rent-money {
  .el-input__inner {
    padding: 0 0 0 15px;
  }
  .el-input--mini {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
  .el-dialog__header {
    text-align: left;
  }
  .contractDialogForm {
    .el-dialog__header {
      text-align: center;
    }
    .operationBox {
      span {
        cursor: pointer;
        color: #337ab7;
      }
      span:hover {
        color: #00a0e6;
      }
    }
    .contractDialogLine {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      line-height: 30px;
      padding: 0 15px;
    }
    .contractDialogLine:hover {
      background-color: #eeeeee;
    }
  }
  .detail-item{
    display: flex;
    justify-content:space-between;
    align-items: center;
    margin: 10px 20px;
    font-size:14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingBill/ParkingCouponBill.vue